import { createFileRoute } from '@tanstack/react-router';
import { MasterExpenditureItemsPage } from '@/pages/master-management/ui/MasterExpenditureItemsPage';
import { paginationSchema, routeValidateQuerySearch } from '@/shared/lib/route';

export const Route = createFileRoute('/_protected/master/expenditure-items')({
  component: MasterExpenditureItemsPage,
  validateSearch: (record) =>
    routeValidateQuerySearch({
      record,
      usePaginationSchema: true,
      withPaginationSchema: paginationSchema,
      defaultValues: undefined,
    }),
});
